import { FC, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { Icon } from 'common-components';
import styles from './tag.module.scss';
import { TagProps } from './tagTypes';
import ActionsMenu from '../adminPanel/credentialCard/actionsMenu/actionsMenu';
import { Popper } from '../uiLibraryImports';
import { useOuterClick } from '../utils';

const Tag: FC<TagProps> = (props: TagProps) => {
    const {
        title,
        onTagClick,
        isCheckedCallback = false,
        tagKey,
        isMarked,
        isDisabled,
        canCheck = true,
        hasActions = false,
        count,
        onDelete,
        style = {},
        onEditHandler,
        toggleCallback
    } = props;
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const [toggleActions, setToggleActions] = useState<boolean>(false);

    const ref = useRef<HTMLDivElement>(null);
    const popperRef = useRef() as React.MutableRefObject<HTMLDivElement>;

    useEffect(() => {
        setIsChecked(isCheckedCallback);
    }, [isCheckedCallback, toggleCallback]);

    useOuterClick(popperRef, () => {
        setToggleActions(false);
    });

    const onClick = () => {
        if (!canCheck) {
            return;
        }
        setIsChecked(!isChecked);
        onTagClick?.(tagKey, !isChecked);
    };

    const onActions = (_event: any) => {
        _event.stopPropagation();
        setToggleActions(true);
    };

    const onEdit = () => {
        onEditHandler?.();
        setToggleActions(false);
    };

    const onDeleteAction = () => {
        onDelete?.(tagKey);
        setToggleActions(false);
    };

    const combinedTitle = count ? `${title} (${count})` : title;

    return (
        <div
            data-testid="tag"
            className={classNames(
                styles['tag-container'],
                isChecked && styles['checked-tag'],
                !isChecked && isMarked && styles['marked-tag'],
                isDisabled && styles['disabled-tag']
            )}
            onClick={() => !isDisabled && onClick()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            ref={ref}
            style={style}
        >
            <span>{combinedTitle}</span>
            {isHovered && hasActions && !toggleActions && (
                <div className={styles['actions-container']} onClick={e => onActions(e)}>
                    <Icon name="kebab" className={styles['icon-container']} style={{ display: 'flex' }} />
                </div>
            )}
            <Popper open={toggleActions} anchorEl={ref.current} ref={popperRef} placement={'bottom-start'}>
                <ActionsMenu onEdit={onEdit} onDelete={onDeleteAction} />
            </Popper>
        </div>
    );
};

export default Tag;
